import { BadgeVerifiedCredentials } from '@seek/certsy-ui';
import { useTranslations } from '@vocab/react';

import translations from './.vocab';
export const VerifiedCredentialBadge: React.FC = () => {
  const { t } = useTranslations(translations);
  return (
    <BadgeVerifiedCredentials>
      {t('VERIFIED_CREDENTIALS')}
    </BadgeVerifiedCredentials>
  );
};
